import { render, staticRenderFns } from "./ProdesCerrado.vue?vue&type=template&id=6df1028f&lang=pug"
import script from "./ProdesCerrado.vue?vue&type=script&lang=js"
export * from "./ProdesCerrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports